import { render, staticRenderFns } from "./InternalRatesAdmin.vue?vue&type=template&id=cd4a2e2c&scoped=true&"
import script from "./InternalRatesAdmin.vue?vue&type=script&lang=js&"
export * from "./InternalRatesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./InternalRatesAdmin.vue?vue&type=style&index=0&id=cd4a2e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4a2e2c",
  null
  
)

export default component.exports